import React from 'react';
import heroPhoneMockup from '../assets/hero_phone_mockup.png';

export default function PhoneMockup() {
  return (
    <div className="relative max-w-[340px] md:max-w-[400px] mx-auto animate-float">
      <div className="absolute inset-0 bg-[#000000]/20 rounded-4xl blur-2xl -z-10" />
      <img
        src={heroPhoneMockup}
        alt="PFP AI Studio Phone Mockup"
        className="w-full h-auto drop-shadow-[0_25px_35px_rgba(0,0,0,0.5)] transition-transform duration-500 hover:scale-105"
      />
    </div>
  );
}
